import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ce3f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "checkout-inner-container checkout-inner-container--card"
}
const _hoisted_2 = { class: "checkout-details" }
const _hoisted_3 = { class: "checkout-actions" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "checkout-buy-with-card"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "checkout-buy-with-card"
}
const _hoisted_9 = {
  key: 1,
  class: "checkout-buy-with-card"
}
const _hoisted_10 = { class: "checkout-card-input" }

import { BigNumber } from '@ethersproject/bignumber';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import {
  SAVED_EMAIL_LOCAL_STORAGE_KEY,
  SAVED_RECIPIENT_ADDRESS_LOCAL_STORAGE_KEY,
} from '@/common/constants';
import CardPaymentForm from '@/components/checkout/CardPaymentForm.vue';
import CardPaymentProcessingPage from '@/components/checkout/CardPaymentProcessingPage.vue';
import CheckoutItems from '@/components/checkout/CheckoutItems.vue';
import CheckoutSuccessPage from '@/components/checkout/CheckoutSuccessPage.vue';
import MintingQuantityError from '@/components/checkout/MintingQuantityError.vue';
import Email from '@/components/Email.vue';
import EmailInput from '@/components/EmailInput.vue';
import NumberToPurchaseInput from '@/components/NumberToPurchaseInput.vue';
import RecipientAddress from '@/components/RecipientAddress.vue';
import RecipientAddressInput from '@/components/RecipientAddressInput.vue';
import SpecialNetworkBanner from '@/components/SpecialNetworkBanner.vue';
import Spinner from '@/components/Spinner.vue';
import { useConfetti } from '@/composables/confetti';
import { tryGetLocalStorage, trySetLocalStorage } from '@/lib/claimUtil';
import * as telemetry from '@/lib/telemetry';
import { SignatureSchema, useClaimStore } from '@/store/claimStore';

interface BuyWithEthPageProps {
  onSuccess?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyWithCardPage',
  props: {
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const store = useClaimStore();
const { addConfetti } = useConfetti();

const purchaseSucceded = ref(false);

const initialEmail = ref<string | null>(null);
const initialAddress = ref<string | null>(null);

const email = ref('');

const allowListFlowState = ref<'enter-details' | 'payment-details'>('enter-details');

const isProcessingCardPayment = ref(false);
const paymentMethod = ref<'eth' | 'card'>('eth');

onBeforeMount(() => {
  initialEmail.value = tryGetLocalStorage(SAVED_EMAIL_LOCAL_STORAGE_KEY);
  initialAddress.value = tryGetLocalStorage(SAVED_RECIPIENT_ADDRESS_LOCAL_STORAGE_KEY);
});

onMounted(() => {
  store.fetchingFiatPricesExternally();
});

const onEmailChanged = (newEmail: string) => {
  email.value = newEmail;
};

const onRecipientAddressChanged = async (newAddress: string) => {
  store.setMintForWallet(newAddress);

  if (newAddress) {
    await store.resetMerkleData();
  }
};

const canGoToPaymentDetails = computed(() => {
  return !!email.value && !!store.mintForWallet && store.canMint && !store.isResetingMerkleData;
});

const onCardPaymentStarted = () => {
  telemetry.paymentAttempt(
    'card',
    store.tokensToPurchase,
    store.mintForWallet ? 'different-wallet' : 'custodial-wallet'
  );
  isProcessingCardPayment.value = true;
};

const onCardPaymentSuccess = (paymentMethodType: string) => {
  addConfetti();

  paymentMethod.value = 'card';
  isProcessingCardPayment.value = false;
  purchaseSucceded.value = true;

  telemetry.paymentSuccess(
    'card',
    store.tokensToPurchase,
    store.mintForWallet ? 'different-wallet' : 'custodial-wallet',
    paymentMethodType
  );

  // Save their wallet and email address if successful mint!
  trySetLocalStorage(SAVED_EMAIL_LOCAL_STORAGE_KEY, email.value);

  if (store.mintForWallet) {
    trySetLocalStorage(SAVED_RECIPIENT_ADDRESS_LOCAL_STORAGE_KEY, store.mintForWallet);
  }

  if (props.onSuccess) {
    props.onSuccess();
  }
};

const onCardPaymentError = () => {
  isProcessingCardPayment.value = false;
  telemetry.paymentError(
    'card',
    store.tokensToPurchase,
    store.mintForWallet ? 'different-wallet' : 'custodial-wallet'
  );
};

const onCardPaymentCostChanged = (
  priceSubtotalWithManifoldFees: BigNumber,
  finalPrice: BigNumber
) => {
  store.updateFiatPricesFromExternalWidget(priceSubtotalWithManifoldFees, finalPrice);
};

watch(
  () => store.tokensToPurchase,
  // Changes to false when onCardPaymentCostChanged is called
  () => {
    store.fetchingFiatPricesExternally();
  }
);

return (_ctx: any,_cache: any) => {
  return (purchaseSucceded.value)
    ? (_openBlock(), _createBlock(CheckoutSuccessPage, _mergeProps({
        key: 0,
        "payment-method": 'card',
        email: email.value,
        "recipient-address": _unref(store).mintForWallet
      }, _ctx.$attrs), null, 16, ["email", "recipient-address"]))
    : (isProcessingCardPayment.value)
      ? (_openBlock(), _createBlock(CardPaymentProcessingPage, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(store).signatureSchema === _unref(SignatureSchema).NONE)
              ? (_openBlock(), _createBlock(NumberToPurchaseInput, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(CheckoutItems, { "show-in-fiat": "" }),
            _createVNode(SpecialNetworkBanner, { class: "checkout-network" })
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_unref(store).hasAllowlist)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (allowListFlowState.value === 'enter-details')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(EmailInput, {
                          "initial-email": initialEmail.value,
                          onOnEmailChanged: onEmailChanged
                        }, null, 8, ["initial-email"]),
                        _createVNode(RecipientAddressInput, {
                          "initial-address": initialAddress.value,
                          onOnAddressChanged: onRecipientAddressChanged,
                          required: ""
                        }, null, 8, ["initial-address"]),
                        _createVNode(MintingQuantityError),
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (allowListFlowState.value = 'payment-details')),
                          class: "campaign-buy-button",
                          disabled: !canGoToPaymentDetails.value
                        }, [
                          (_unref(store).isResetingMerkleData)
                            ? (_openBlock(), _createBlock(Spinner, {
                                key: 0,
                                dark: ""
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, "Next"))
                        ], 8, _hoisted_6)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(Email, { email: email.value }, null, 8, ["email"]),
                        _createVNode(RecipientAddress, {
                          address: _unref(store).mintForWallet || null
                        }, null, 8, ["address"]),
                        _createVNode(CardPaymentForm, {
                          email: email.value,
                          "on-payment-started": onCardPaymentStarted,
                          "on-success": onCardPaymentSuccess,
                          "on-error": onCardPaymentError,
                          "on-cost-changed": onCardPaymentCostChanged,
                          "on-recipient-wallet-changed": () => {}
                        }, null, 8, ["email"])
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(EmailInput, {
                    "initial-email": initialEmail.value,
                    onOnEmailChanged: onEmailChanged
                  }, null, 8, ["initial-email"]),
                  _createVNode(RecipientAddressInput, {
                    "initial-address": initialAddress.value,
                    onOnAddressChanged: onRecipientAddressChanged
                  }, null, 8, ["initial-address"]),
                  _createVNode(MintingQuantityError),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(CardPaymentForm, {
                      email: email.value,
                      "on-payment-started": onCardPaymentStarted,
                      "on-success": onCardPaymentSuccess,
                      "on-error": onCardPaymentError,
                      "on-cost-changed": onCardPaymentCostChanged,
                      "on-recipient-wallet-changed": () => {}
                    }, null, 8, ["email"])
                  ])
                ]))
          ])
        ]))
}
}

})